import { render, staticRenderFns } from "./rfib.vue?vue&type=template&id=5cb0c1a3&scoped=true"
import script from "./rfib.vue?vue&type=script&lang=js"
export * from "./rfib.vue?vue&type=script&lang=js"
import style0 from "./rfib.vue?vue&type=style&index=0&id=5cb0c1a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0c1a3",
  null
  
)

export default component.exports